(function () {
  'use strict';

  // The card's text overlay (.card__content) is absolutely positioned above the
  // image and carries the product link, so pointer events never reach the media.
  // Bind to the card wrapper instead and drive the track from there.

  function hydrate(card) {
    card.querySelectorAll('[data-cc-lazy]').forEach(function (slide) {
      if (slide.dataset.ccDone) return;
      slide.dataset.ccDone = '1';
      var img = document.createElement('img');
      img.src = slide.dataset.ccLazy;
      img.alt = slide.dataset.ccAlt || '';
      img.loading = 'lazy';
      img.className = 'motion-reduce';
      slide.appendChild(img);
    });
  }

  function goTo(card, idx) {
    var media = card.querySelector('[data-cc-media]');
    var track = card.querySelector('[data-cc-track]');
    if (!media || !track) return;
    var n = card.querySelectorAll('.cc-slide').length;
    idx = Math.max(0, Math.min(n - 1, idx));
    media.dataset.index = idx;
    track.style.transform = 'translateX(' + -idx * 100 + '%)';
    card.querySelectorAll('.cc-dot').forEach(function (d, k) {
      d.classList.toggle('cc-on', k === idx);
    });
    // goTo clamps, so an arrow at either end has nowhere to go. Hiding it
    // says where you are as plainly as the dots do.
    var prev = card.querySelector('[data-cc-prev]');
    var next = card.querySelector('[data-cc-next]');
    if (prev) prev.hidden = idx <= 0;
    if (next) next.hidden = idx >= n - 1;
  }

  function step(card, by) {
    var media = card.querySelector('[data-cc-media]');
    if (!media) return;
    hydrate(card);
    goTo(card, (parseInt(media.dataset.index, 10) || 0) + by);
  }

  function bind(card) {
    if (card.dataset.ccBound) return;

    /* A card inside a horizontal rail must not bind the swipe. Its
       non-passive touchmove calls preventDefault on horizontal movement to
       drive the image carousel, which swallowed the drag the rail itself
       needed to scroll — the rail simply would not move. */
    if (card.classList.contains('cc-compact')) return;

    card.dataset.ccBound = '1';

    var media = card.querySelector('[data-cc-media]');
    var track = card.querySelector('[data-cc-track]');
    if (!media || !track) return;
    if (card.querySelectorAll('.cc-slide').length < 2) return;

    // The whole card is a link, so an arrow has to stop the click reaching it.
    ['prev', 'next'].forEach(function (dir) {
      var btn = card.querySelector('[data-cc-' + dir + ']');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stopNudging();
        step(card, dir === 'next' ? 1 : -1);
      });
    });

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var width = 1;
    var active = false;
    var decided = false;
    var horizontal = false;

    card.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.cc-act') || e.target.closest('.cc-arrow')) return;
      active = true;
      decided = false;
      horizontal = false;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
      width = card.clientWidth || 1;
      hydrate(card);
    });

    card.addEventListener('pointermove', function (e) {
      if (!active) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;

      // Decide once whether this gesture is a swipe or a page scroll.
      if (!decided) {
        if (Math.abs(mx) < 3 && Math.abs(my) < 3) return;
        decided = true;
        horizontal = Math.abs(mx) > Math.abs(my);
        if (horizontal) {
          track.classList.add('cc-dragging');
          card.setPointerCapture(e.pointerId);
        }
      }
      if (!horizontal) return;

      e.preventDefault();
      dx = mx;
      var base = -parseInt(media.dataset.index, 10) * width;
      track.style.transform = 'translateX(' + (base + dx) + 'px)';
    });

    function release() {
      if (!active) return;
      active = false;
      if (!horizontal) return;
      track.classList.remove('cc-dragging');
      var i = parseInt(media.dataset.index, 10);
      if (dx < -30) {
        i++;
      } else if (dx > 30) {
        i--;
      }
      goTo(card, i);
    }

    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);

    // touch-action: pan-y still lets the browser scroll on the vertical drift
    // of a horizontal swipe. Pointer events cannot stop that — only a
    // non-passive touchmove calling preventDefault can. Lock the axis on the
    // first few pixels, then cancel scrolling for the rest of the gesture.
    var tX = 0;
    var tY = 0;
    var tAxis = null;

    card.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        tX = e.touches[0].clientX;
        tY = e.touches[0].clientY;
        tAxis = null;
      },
      { passive: true }
    );

    card.addEventListener(
      'touchmove',
      function (e) {
        if (e.touches.length !== 1) return;
        if (tAxis === null) {
          var adx = Math.abs(e.touches[0].clientX - tX);
          var ady = Math.abs(e.touches[0].clientY - tY);
          if (adx < 3 && ady < 3) return;
          tAxis = adx > ady ? 'x' : 'y';
        }
        if (tAxis === 'x') e.preventDefault();
      },
      { passive: false }
    );

    function clearAxis() {
      tAxis = null;
    }
    card.addEventListener('touchend', clearAxis, { passive: true });
    card.addEventListener('touchcancel', clearAxis, { passive: true });

    // A drag must not also follow the card's product link.
    card.addEventListener(
      'click',
      function (e) {
        if (horizontal && Math.abs(dx) > 6) {
          e.preventDefault();
          e.stopPropagation();
          dx = 0;
        }
      },
      true
    );
  }

  /*
   * Hint that the image can be swiped — and keep hinting until someone does.
   *
   * It used to run once per SESSION, on the first card on the page
   * (querySelector, not querySelectorAll), gated behind sessionStorage. For
   * most visits that was one small movement, eleven hundred milliseconds
   * after load, on one card — easy to miss and then never shown again, so a
   * shopper could browse the whole shop without learning the photographs
   * move.
   *
   * Now it repeats a few times, spaced far enough apart not to fidget, and
   * stops the moment anyone touches the card — at which point they know.
   * Arrows carry the message on their own; this is for the people who are
   * already scrolling and not looking at the edges.
   */
  var NUDGE_TIMES = 3;
  var NUDGE_GAP = 7000;
  var nudgeTimer = null;

  function stopNudging() {
    if (nudgeTimer) window.clearTimeout(nudgeTimer);
    nudgeTimer = null;
  }

  function nudgeLoop() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var card = document.querySelector('.cc-enhanced:not(.cc-compact)');
    if (!card) return;
    if (card.querySelectorAll('.cc-slide').length < 2) return;
    var track = card.querySelector('[data-cc-track]');
    if (!track) return;

    // Any contact at all means the hint has done its job.
    card.addEventListener('pointerdown', stopNudging, { once: true });

    var shown = 0;
    function tick() {
      if (shown >= NUDGE_TIMES) return;
      shown += 1;
      hydrate(card);
      track.classList.add('cc-nudge');
      track.addEventListener('animationend', function handler() {
        track.classList.remove('cc-nudge');
        track.removeEventListener('animationend', handler);
      });
      nudgeTimer = window.setTimeout(tick, NUDGE_GAP);
    }
    nudgeTimer = window.setTimeout(tick, 1100);
  }

  /*
   * THE SAME LIST THE PRODUCT PAGE WRITES.
   *
   * `sujatra:saved` is an array of product ids, written by product-wish.liquid.
   * The card heart used to toggle aria-pressed and store NOTHING, so a piece
   * saved from a card was forgotten on the next click and a piece saved from its
   * product page showed an empty heart on every card of it. One key, one format,
   * both directions.
   *
   * Ids are compared as strings: the product page reads its id off a data
   * attribute, so that is what is in the list, and a number here would never
   * match.
   */
  var WISH_KEY = 'sujatra:saved';
  var WISH_META = 'sujatra:saved:meta';

  function savedList() {
    try { return JSON.parse(window.localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
  }

  function writeSaved(list) {
    /* Capped and tail-kept, exactly as product-wish does — the two must not
       disagree about what the list holds. */
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list.slice(-200))); }
    catch (e) { /* private window, or storage blocked: the heart just will not stick */ }
  }

  /*
   * The snapshot the saved drawer renders from.
   *
   * Lifted off the card's own bag button, which already carries the handle,
   * title, price and image for quick-add — so saving costs no extra data and
   * cannot disagree with what the card is showing. The variants come off the
   * heart itself, so a piece saved from a grid can be sized in the drawer
   * exactly as one saved from its product page.
   */
  function rememberWish(card, id, on) {
    try {
      var m = JSON.parse(window.localStorage.getItem(WISH_META)) || {};
      if (!on) { delete m[id]; }
      else {
        var bag = card && card.querySelector('[data-cc-quickadd]');
        var link = card && card.querySelector('a[href*="/products/"]');
        m[id] = {
          h: (bag && bag.getAttribute('data-product-handle'))
             || (link ? (link.getAttribute('href').split('?')[0].split('/products/')[1] || '') : ''),
          t: (bag && bag.getAttribute('data-product-title')) || '',
          p: (bag && bag.getAttribute('data-product-price')) || '',
          i: (bag && bag.getAttribute('data-product-image')) || '',
          vs: (card && card.querySelector('.cc-wish[data-wish-variants]')
               && card.querySelector('.cc-wish[data-wish-variants]').getAttribute('data-wish-variants')) || ''
        };
      }
      window.localStorage.setItem(WISH_META, JSON.stringify(m));
    } catch (e) { /* no storage: the id still saves, the drawer shows a bare row */ }
  }

  function paintWish(btn, on) {
    btn.classList.toggle('cc-wish--on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Saved' : 'Save for later');
  }

  /** Show what is already saved, on first paint and after every grid swap. */
  function paintAllWishes(root) {
    var list = savedList();
    (root || document).querySelectorAll('.cc-wish[data-wish-id]').forEach(function (btn) {
      paintWish(btn, list.indexOf(String(btn.getAttribute('data-wish-id'))) !== -1);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.cc-enhanced').forEach(bind);
    paintAllWishes(root);
  }

  function boot() {
    init(document);
    nudgeLoop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-bind after facet filtering or pagination swaps the grid.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.ccInitCards = init;

  document.addEventListener('click', function (e) {
    var w = e.target.closest('.cc-wish');
    if (!w) return;
    e.preventDefault();

    var id = w.getAttribute('data-wish-id');
    if (!id) {
      /* No id on this card — toggle so the tap is not dead, but there is
         nothing to store against. */
      paintWish(w, w.getAttribute('aria-pressed') !== 'true');
      return;
    }

    id = String(id);
    var list = savedList();
    var at = list.indexOf(id);
    if (at === -1) list.push(id); else list.splice(at, 1);
    writeSaved(list);
    rememberWish(w.closest('.cc-enhanced'), id, at === -1);

    /* Every card for the same garment, not just the one tapped: a grid can show
       the same piece twice, and two hearts disagreeing is a bug a shopper sees
       immediately. */
    document.querySelectorAll('.cc-wish[data-wish-id="' + id + '"]').forEach(function (btn) {
      paintWish(btn, at === -1);
    });
  });
})();